import lightColors from 'assets/scss/_themes-vars-light-mode.module.scss';
import styled from '@emotion/styled';
import { Modal } from '@mui/material';
import { BackgroundImg } from 'assets/images';

export const Wrapper = styled.div`
    background-image: url(${BackgroundImg});
    height: 100vh;
    overflow-y: scroll;
    background-repeat: no-repeat;
    background-size: cover;
`;

export const ModalStyle = styled(Modal)`
    padding: 20px;
    .modal-body {
        svg[data-testid='ClearIcon'] {
            color: ${lightColors.primaryMain};
        }
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 70vw;

        > .modal-main-body {
            background: white;
            border: 2px solid ${lightColors.primaryMain};
            padding: 16px;
            .title {
                padding-bottom: 16px;
            }
        }
    }
    .modal-content {
        max-height: 60vh;
        overflow-y: scroll;
    }
    .modal-footer {
        text-align: center;
        margin-top: 16px;
    }
    img {
        width: 100%;
    }
    .label {
        background: #157700;
        color: white;
        font-size: 1.2rem;
        color: white;
        padding: 8px;
    }
    .quantity {
        font-size: 1.2rem;
        padding: 8px;
        border-bottom: 1px solid #157700;
    }
`;
